import clsx from "clsx";
import st from "@/styles/Ui.module.scss";
import {ReactNode} from "react";

interface Props {
    active: boolean
    icon_left: ReactNode
    icon_right: ReactNode
    left_text: string
    gray_right?: boolean
    left_function():void
    right_function():void
    red_badge_text?:string
}

const MultiButton:React.FC<Props> = (props) => {
    
    const {
        active,
        icon_left,
        icon_right,
        left_text,
        gray_right,
        left_function,
        right_function,
        red_badge_text
    } = props

    
    return (
        <div className={clsx(st.multi_button, active && st.active)}>
            
            <div
                onClick={left_function}
                className={clsx(st.sides, st.left)}
            >
                {icon_left}
                
                {left_text}
                
                {red_badge_text && (
                    <div className={st.red_badge}>
                        {red_badge_text}
                    </div>
                )}
                
            </div>
            
            <div
                onClick={right_function}
                className={clsx(st.sides, st.right, gray_right && st.gray_right)}
            >
                {icon_right}
            </div>
        </div>
    )
}

export default MultiButton